import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  NbDialogService,
  NbPopoverDirective,
  NbSearchService,
  NbSidebarService,
  NbThemeService,
  NbToastrService,
} from "@nebular/theme";

import { environment } from "../../../../environments/environment";
import * as _ from "lodash";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, combineLatest, EMPTY, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  filter,
  map,
  startWith,
  take,
  takeUntil,
  tap,
} from "rxjs/operators";
import { UserData } from "../../../@core/data/users";
import { DeclarationPromptService } from "../../../@core/declaration-prompt/declaration-prompt.service";
import { SessionService } from "../../../@core/session/session.service";
import {
  profileImageLoadedState,
  profileImageLoadingErrorState,
  profileImageLoadingState,
} from "../../../@core/session/session.state";
import { Store } from "../../../@core/store/store";
import { AppLocalStorage } from "../../../@core/utils/local-storage.util";
import { GaugeChartService } from "../../../pages/gauge-chart/gauge-chart.service";
import { HeaderService } from "./service/header.service";
import {
  ProfileLoadedState,
  ProfileLoadingErrorState,
  ProfileLoadingState,
  RequestsForAttendanceApprovalsLoadedState,
  RequestsForApprovalsLoadedState,
  RequestsForApprovalsLoadingErrorState,
  RequestsForApprovalsLoadingState,
  RequestsForAttendanceApprovalsLoadingErrorState,
  RequestsForAttendanceApprovalsLoadingState,
  RequestsForLeaveApprovalsLoadingState,
  RequestsForLeaveApprovalsLoadedState,
  RequestsForLeaveApprovalsLoadingErrorState,
  RequestsForCarApprovalsLoadingState,
  RequestsForCarApprovalsLoadedState,
  RequestsForCarApprovalsLoadingErrorState,
  RequestsForAccommodationApprovalsLoadingState,
  RequestsForAccommodationApprovalsLoadedState,
  RequestsForAccommodationApprovalsLoadingErrorState,
  SynergyPendingRequestsLoadingState,
  SynergyPendingRequestsLoadedState,
  SynergyPendingRequestsLoadingErrorState,
  ForexPendingRequestsLoadingState,
  ForexPendingRequestsLoadedState,
  ForexPendingRequestsLoadingErrorState,
} from "./service/header.state";
import { HomeService } from "../../../pages/home/service/home.service";
import {
  BingSearchLoadingState,
  BingSearchLoadedState,
  BingSearchLoadingErrorState,
  ApplicationSearchLoadingState,
  ApplicationSearchLoadedState,
  ApplicationSearchLoadingErrorState,
} from "../../../pages/home/service/home.state";
import { trigger, transition, style, animate } from "@angular/animations";
import { FormControl } from "@angular/forms";
import { IntranetService } from "../../../pages/home/intranet/service/intranet.service";
import { PeopleDetailsComponent } from "./people-details/people-details.component";
import { DynamicStackService } from "../../../pages/home/dynamic-stack/service/dynamic-stack.service";
import {
  RemindersLoadedState,
  RemindersLoadingErrorState,
  RemindersLoadingState,
} from "../../../pages/home/dynamic-stack/service/dynamic-stack.state";
import {
  GetAllCategoriesLoadedState,
  GetAllCategoriesLoadingErrorState,
  GetAllCategoriesLoadingState,
} from "../../../pages/applications/service/applications.state";
import { ApplicationService } from "../../../pages/applications/service/applications.service";
import { APP_ICONS } from "./appIconMapping";
import { PermissionService } from "../../../pages/ai-chatwoot-buddy/ALINA-permission/permission.service";
import { UserTrackingService } from "../../../@core/utils";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";

export interface Group {
  name: string;
  children: string[];
}

export interface MenuItem {
  label: string;
  url: string;
  icon: string;
  children?: MenuItem[];
}

export interface appMenuItem {
  label: string;
  url: string;
  children?: appMenuItem[];
}

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("enterAnimation", [
      transition(":enter", [
        style({ transform: "translateX(100%)", opacity: 0 }),
        animate("500ms", style({ transform: "translateX(0)", opacity: 1 })),
      ]),
      transition(":leave", [
        style({ transform: "translateX(0)", opacity: 1 }),
        animate("100ms", style({ transform: "translateX(100%)", opacity: 0 })),
      ]),
    ]),
    trigger("slideInOut", [
      transition(":enter", [
        style({ transform: "translateX(100%)" }),
        animate("100ms ease-in", style({ transform: "translateX(0)" })),
      ]),
      transition(":leave", [
        animate("100ms ease-in", style({ transform: "translateX(100%)" })),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ViewChild("searchInput") searchInputRef: ElementRef;
  @ViewChild("searchDropdown") searchDropdown!: ElementRef;
  @ViewChild("quickActionCloseButton") quickActionCloseButton: ElementRef<HTMLButtonElement>;
  @ViewChild("quickActionLauncher") quickActionLauncher: ElementRef<HTMLButtonElement>;

  private destroy$: Subject<void> = new Subject<void>();
  private quickActionsPreviousFocus: HTMLElement | null = null;
  userPictureOnly: boolean = false;
  user: any;

  isShowing: boolean = false;
  showPopupWidgetPicker = false;
  showQuickActionLauncher = false;
  declarationStatus: string | null = null;

  activeButton: string = "home"; // Initialize with the default active button
  currentTheme = "default";

  showCancelLogo = false;
  activeLink: string = "pages/home";
  // activeLink:string;
  username: string = "";
  employeeId: any;
  profileImage: any;
  private cmsbase_url: string;
  LINANAME: string;

  kyl_access: boolean;
  quiz_access: boolean;
  townhall: boolean;
  showQuizNotify: boolean;
  showTownhallNotify: boolean;
  hasActiveISMS: any;
  hasActiveDataPrivacy: any;
  showCms: boolean;
  hasCmsAccess: boolean;
  appraisalData: boolean = false;
  showPopup: boolean = false;
  menuItems = [
    { title: "Home", link: "pages/home" },
    { title: "My teams", link: "pages/my-team" },
    { title: "Applications", link: "pages/applications" },
    { title: "Feed", link: "/feed" },
    { title: "Genie", link: "pages/genie" },
  ];

  // profile = {
  //   name: "John Doe",
  //   title: "Administrator",
  //   picture: this.cmsbase_url+"wp-content/uploads/2025/05/dumy.jpg",
  //   link: "/profile",
  // };
  profileData: any = {};
  userImage: any;
  greetingMessage: string = "";
  searchValue = "";
  searchData: any[] = [];
  searchControl = new FormControl("");
  showSearchResults = false; // Control visibility of the results list
  selectedResult: any;
  applicationSearchLoading: boolean;

  groups: Group[];
  searchGroups: Group[];
  filteredGroups$: Observable<Group[]>;
  activeTabIndex$ = new BehaviorSubject<number>(0);
  inputFormControl: FormControl = new FormControl("");

  showSearchInput: boolean = false;

  accountData: any;
  private profileDetails: any;
  applicationSearchEmpty: boolean;

  currentUrl: string = "";
  feedBack: boolean = false;

  //my reminders
  remindersHeading: string = "My Reminders";
  reminders: any[] = [];
  remindersLoading: boolean = false;
  showMoreHeader: boolean = false;

  menu: MenuItem[] = [
    {
      label: "Board of Directors",
      url: "board-of-directors",
      icon: "",
    },
  ];

  departments: MenuItem[] = [
    {
      label: "Departments",
      url: "",
      icon: "",
      children: [
        {
          label: "Administration",
          url: "departments",
          icon: "/assets/icons-new/Administration_Icon.png",
        },
        {
          label: "Business Operations",
          url: "departments",
          icon: "/assets/icons-new/Business-Operations_Icon.jpg",
        },
        {
          label: "Data Privacy",
          url: "departments",
          icon: "/assets/icons-new/Business-Operations_Icon.jpg",
        },
        {
          label: "F&A Legal",
          url: "departments",
          icon: "/assets/icons-new/F&A_Legal.png",
        },
        {
          label: "HR",
          url: "departments",
          icon: "/assets/icons-new/HR_Icon.png",
        },
        {
          label: "Infotainment",
          url: "departments",
          icon: "/assets/icons-new/Infotainment_Icon.jpg",
        },
        {
          label: "Marketing",
          url: "departments",
          icon: "/assets/icons-new/Marketing_Icon.png",
        },
        {
          label: "Operations and WMG",
          url: "departments",
          icon: "/assets/icons-new/Quality_icon.png",
        },
        {
          label: "Procurement",
          url: "departments",
          icon: "/assets/icons-new/Procurement_Icon.png",
        },
        {
          label: "Quality",
          url: "departments",
          icon: "/assets/icons-new/Quality_icon.png",
        },
      ],
    },
  ];

  appMenu: appMenuItem[] = [];

  boardofdirectors: boolean;
  categoriesList: any;
  categoriesData: any;
  loading: boolean;
  categoryGradient: any;
  categoriesListCopy: any;
  groupedCategoriesData: any;
  newDataChild: any;
  newData: any;
  myteamsv2: boolean = false;
  approval: boolean = false;
  isMnAUser: any;
  hasActiveTownhall: any;
  hasActiveQuiz: any;
  apps: boolean;
  AlinaAccess: boolean = false;
  showAppsDropdown: boolean;
  newLogo: string;
  cancelLogo: string;
  envelope: string;
  Telephone: string;
  locality: string;
  showForex: boolean = false;
  showSearchTab: boolean = false;
  searText: string;
  showFeedbackCapture: boolean = false;
  showFeedOverlay = false;
  btnDisabled: boolean = true;
  hideCLosBtn: boolean = true;
  isConditionMet: boolean = false;
  empFeedbackDiv: boolean;
  showLoader: boolean = false;
  hasEnablingFunAccess: any;
  hasMoodReportingAccess: boolean = false;
  empQuizPopup: boolean;
  showQuizOverlay = false;
  showAppraisalOverlay = false;
  QuizTItleText = 'InQuizitive'
  QuizInnerHead = 'You have a quiz pending for today.'
  QuizInnerPara = 'Would you like to attempt it now?'
  showQuizPopup: boolean;
  talentAIData = false;
  TalentTitleText = 'Talent AI'
  TalentInnerHead = 'Talent AI is Live Now. Please log in to Talent AI and update your skills.'
  TalentInnerPara = 'Log in to MyLTTS → My Apps → Org → Talent AI'
  talentAIPopup?: boolean;
  showTalentOverlay = false;


  showComment = false;
  commentText = '';
  isExpanded = false;

  moodChipsMap: { [key: string]: { label: string }[] } = {
    Excellent: [
      { label: 'Achievement' },
      { label: 'Supportive Leadership' },
      { label: 'Friends @work' },
      { label: 'Positive and energetic culture' },
      { label: 'Freedom to express views' },
      { label: 'Office Infrastructure' },
      { label: 'Engagement in office' },
      { label: 'Consistent Recognition' },
      { label: 'Motivating Workplace' },
      { label: 'Security and sense of belonging' },
      { label: 'Interesting Work / Project' },
      { label: 'Other' }
    ],
    Happy: [
      { label: 'Good team support' },
      { label: 'Supportive Management' },
      { label: 'Support on matters other than work' },
      { label: 'Managers are approachable' },
      { label: 'Organization communicates decision rationale' },
      { label: 'Infrastructure is conducive' },
      { label: 'Respectful Workplace' },
      { label: 'Manageable work' },
      { label: 'Office Infrastructure' },
      { label: 'Decent communication flow' },
      { label: 'Friendly colleagues' },
      { label: 'Other' }
    ],
    Okay: [
      { label: 'Work Environment' },
      { label: 'No standard work culture' },
      { label: 'Resources' },
      { label: 'Low Confidence / Self belief' },
      { label: 'Limited collaboration' },
      { label: 'Sub-optimal Communication' },
      { label: 'Adequate Team support' },
      { label: 'Feeling disconnected' },
      { label: 'Inconsistent Recognition' },
      { label: 'Other' }
    ],
    NotOkay: [
      { label: 'Transparent Communication' },
      { label: 'Communication - Transparency, Frequency' },
      { label: 'Job Security, Psycological safety @workplace' },
      { label: 'Support for managing Escalation / Firefighting' },
      { label: 'Infrastructure' },
      { label: 'Uneven Workload' },
      { label: 'Lack of Recognition' },
      { label: 'Medical Benefits' },
      { label: 'Culture' },
      { label: 'Collaboration' },
      { label: 'Stressfree work environment' },
      { label: 'Growth (Promotion, Increment, Role Change etc)' },
      { label: 'Mentoring' },
      { label: 'Inclusivity' },
      { label: 'Other' }
    ]
  };
  mood_analytics: any;

  get chips(): { label: string }[] {
    return this.activeClassName ? (this.moodChipsMap[this.activeClassName] ?? []) : [];
  }

  selectedChipLabel: string | null = null;
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showSearchInput) {
      return;
    }

    const clickedInsideSearchInput =
      this.searchInputRef?.nativeElement.contains(event.target);
    const clickedInsideSearchDropdown =
      this.searchDropdown?.nativeElement.contains(event.target);

    if (!clickedInsideSearchInput && !clickedInsideSearchDropdown) {
      this.showSearchInput = false;
      this.inputFormControl.reset();
      this.closeSearchTab();
    }
  }

  // Property to track the currently active item's class name
  activeClassName: string | null = null;
  // Property to display the output text
  outputText: string = '';
  disableMood: boolean = false;
  headingText = 'Employee Pulse'
  innerHead = ""
  private token: string;
  @ViewChild('myButton') myButtonRef: ElementRef;
  notifications: any[] = [];
  constructor(
    private themeService: NbThemeService,
    private userService: UserData,
    private router: Router,
    private headerService: HeaderService,
    private sessionService: SessionService,
    private searchService: NbSearchService,
    private homeservice: HomeService,
    private intranetService: IntranetService,
    private sidebarService: NbSidebarService,
    private dialogService: NbDialogService,
    private cdr: ChangeDetectorRef, // Add this line
    private activatedRoute: ActivatedRoute,
    private dynamicStackService: DynamicStackService,
    private applicationService: ApplicationService,
    private permissionService: PermissionService,
    private userTrackingService: UserTrackingService,
    private toastrService: NbToastrService,
    private http: HttpClient,
    private gaugeChartService: GaugeChartService,
    private declarationPromptService: DeclarationPromptService
  ) {
  }


  removeSpecialCharacters(input: string): string {
    return input.replace(/[^a-zA-Z0-9 ]/g, " ");
  }

  ngOnInit() {
    this.accountData = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
    this.profileDetails = AppLocalStorage.get(
      "PROFILE_DATA",
      "PROFILE_DATA"
    );
    this.showAppraisalOverlay = this.showPopup;
    this.kyl_access = environment.KYL_access;
    this.quiz_access = environment.quiz_access;
    this.empFeedbackDiv = environment.empFeedBack;
    this.hasMoodReportingAccess = this.profileDetails?.hasMoodReportingAccess === true;

    this.declarationPromptService.declarationStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status) => {
        this.declarationStatus = status;
        this.cdr.markForCheck();
      });
    this.mood_analytics = this.profileDetails?.hasMoodReportingAccess;
    this.accountData.profile.employeeName = this.removeSpecialCharacters(
      this.accountData.profile.employeeName
    );
    this.innerHead = 'Hi ' + this.accountData.profile.employeeName + ', How are you Feeling today!'
    this.currentTheme = this.themeService.currentTheme;
    this.cmsbase_url = environment.CMSURL_IMG;
    this.LINANAME = environment.LINA_NAME;

    this.newLogo = this.cmsbase_url + "wp-content/uploads/2025/05/new-logo.png";
    this.cancelLogo =
      this.cmsbase_url + "wp-content/uploads/2025/05/cancel.png";
    this.envelope =
      this.cmsbase_url + "wp-content/uploads/2025/05/Envelope.png";
    this.Telephone =
      this.cmsbase_url + "wp-content/uploads/2025/05/Telephone.png";
    this.locality =
      this.cmsbase_url + "wp-content/uploads/2025/05/locality.png";

    // this.boardofdirectors = window['env'].boardofdirectors == 'true'
    // this.myteamsv2  = window['env'].myteams == 'true'
    // this.approval  = window['env'].approval == 'true';
    this.showForex = window["env"]?.showForex == "true";

    this.myteamsv2 = Boolean(environment.myteamsv2);
    this.approval = Boolean(environment.approval);
    this.boardofdirectors = Boolean(environment.boardofdirectors);
    this.showQuizNotify = Boolean(environment.showQuizNotify);
    this.showTownhallNotify = Boolean(environment.showTownhallNotify);
    this.showQuizPopup = Boolean(environment.quizDailyPopup);
    this.showCms = Boolean(environment.showCms);
    this.getProfileImage(this.accountData?.profile);
    this.fetchTalentAIData();
    //this.showForex  = Boolean(environment.showForex);
    this.fetchAppraisalData();
    this.userService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => (this.user = users.nick));
    this.getUserProfileData();
    this.setGreetingMessage();
    if (this.showForex) {
      this.fetchRequestsForForexApprovalsData(this.accountData?.profile.email);
    }
    this.fetchRequestsForAttendanceApprovals(this.accountData?.profile.email);
    this.fetchRequestsForLeaveApprovals(this.accountData?.profile.employeeId);

    if (this.profileDetails?.isSynergyApprover) {
      this.fetchRequestsForSynergyApprovals(this.accountData?.profile.email);
    }

    // this.check()

    // for global search
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300) // Delay the search action by 500ms
      )
      .subscribe((value: string) => {
        // Call the search method with the input value
        // this.searchRequest(value);

        if (value && value.trim()) {
          this.searchRequest(value.trim());
        } else {
          this.clearSearchResults(); // Clear search results if input is cleared
        }
      });

    this.currentUrl = this.router.url;

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects;
      });

    // this.filteredGroups$ = of(this.groups);

    this.inputFormControl.valueChanges
      .pipe(debounceTime(1000))
      .subscribe((value: string) => {
        if (value && value.trim()) {
          this.searchApplication(value.trim());
          this.searText = value.trim();
          this.userTrackingService.track('Global_Search_Value', { 'value': this.searText }, 'header');
        } else {
          this.filteredGroups$ = of([]);
          this.searchGroups = [];
          this.showSearchTab = false;
          this.activeTabIndex$.next(0);
          this.cdr.detectChanges();
          this.searText = '';
        }
      });

    // this.filteredGroups$ = this.inputFormControl.valueChanges.pipe(
    //   startWith(""),
    //   tap((c) => this.searchApplication(c)),
    //   map((filterString) => this.filter(filterString))
    // );

    //const userId = "955780"
    const userId = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")?.profile
      ?.employeeId;
    this.getRemindersListData(userId);
    this.showFeedbackCapture = false;
    this.showFeedOverlay = false;
    this.loadNotifications();
    this.sessionService.profileDataLoaded$.pipe(
      filter(profileData => !!profileData),
      take(1),
      takeUntil(this.destroy$)
    ).subscribe(profileData => {
      this.profileData = profileData;
      this.profileDetails = profileData;
      this.hasMoodReportingAccess = profileData?.hasMoodReportingAccess === true;
      this.mood_analytics = this.hasMoodReportingAccess;
      this.cdr.markForCheck();
      setTimeout(() => {
        if (this.appraisalData) {
          this.checkAppraisalPopup();
          setTimeout(() => {
            window.open('https://performancemanager10.successfactors.com/sf/pmreviews?bplte_company=LTTS&_s.crb=sD%252fUrUyPwqvVLOngSTT2Dj4o4GHT%252fA3DNv3m39fZqHA%253d#/', '_blank');
          }, 500);
        } else if (this.talentAIData) {
          this.displayTalentAIPopup();
        }
      }, 1000);
    });

    // Decide once after profile data is available, even if declaration status is unavailable.
    combineLatest([
      this.declarationPromptService.declarationStatus$.pipe(map((status) => status ?? 'unavailable')),
      this.sessionService.profileDataLoaded$.pipe(filter((profileData) => !!profileData)),
    ]).pipe(take(1), takeUntil(this.destroy$)).subscribe(() => this.evaluateQuickActionsAutoOpen());

    // Show quiz popup for external users, Talent AI popup for internal users
    // const userEmail = this.accountData?.profile?.email || '';

  }

  displayTalentAIPopup() {
    if (this.appraisalData) {
      return;
    }

    const now = new Date();
    const today = now.toDateString();
    const currentHour = now.getHours();
    const isMorning = currentHour < 12;

    const lastShownDate = localStorage.getItem('talentAILastShownDate');
    const morningShown = localStorage.getItem('talentAIMorningShown') === 'true';
    const afternoonShown = localStorage.getItem('talentAIAfternoonShown') === 'true';

    // Reset flags if it's a new day
    if (lastShownDate !== today) {
      localStorage.setItem('talentAILastShownDate', today);
      localStorage.setItem('talentAIMorningShown', 'false');
      localStorage.setItem('talentAIAfternoonShown', 'false');
    }

    // Show popup if it's morning and hasn't been shown in morning yet
    // Or if it's afternoon and hasn't been shown in afternoon yet
    const shouldShow = (isMorning && !morningShown) || (!isMorning && !afternoonShown);

    if (shouldShow) {
      this.talentAIPopup = true;
      this.showTalentOverlay = true;

      // Mark as shown for the appropriate time period
      if (isMorning) {
        localStorage.setItem('talentAIMorningShown', 'true');
      } else {
        localStorage.setItem('talentAIAfternoonShown', 'true');
      }
    }
  }
  closeTalentPopup() {
    this.talentAIPopup = false;
    this.showTalentOverlay = false;
  }

  async loadNotifications() {
    try {
      const observable: any =
        await this.intranetService.GetTownHallNotifications();
      observable.subscribe({
        next: (data: any) => {
          this.notifications = data || [];
        },

        error: (err: any) => {
          console.error('Error fetching notifications', err);
        }
      });
    } catch (error) {
      console.error('Token error', error);
    }
  }
  async goToEvent(eventId: number) {

    try {
      const observable = await this.intranetService.markNotificationAsSeen();

      observable.subscribe({
        next: () => {
          this.router.navigate(['event-details', eventId]);
          this.showOverlay = !this.showOverlay;
          this.sidebarService.collapse("menu-sidebar");
        },
        error: (err) => {
          this.router.navigate(['event-details', eventId]);
        }

      });

    } catch (error) {

      this.router.navigate(['event-details', eventId]);
    }

  }



  checkDailyPopup() {
    if (!this.showQuizPopup) {
      return;
    }

    const now = new Date();
    const today = now.toDateString();
    const lastShownDate = localStorage.getItem('lastShownDate');
    const lastShownTime = parseInt(localStorage.getItem('lastShownTime') || '0', 10);
    let shownCount = parseInt(localStorage.getItem('shownCount') || '0', 10);

    // 1. Reset logic: If it's a new day, reset the counter
    if (lastShownDate !== today) {
      shownCount = 0;
      localStorage.setItem('lastShownDate', today);
      localStorage.setItem('shownCount', '0');
      localStorage.removeItem('lastShownTime');
    }

    //toggleclose


    const fourHoursInMillis = 4 * 60 * 60 * 1000;
    const timeSinceLastShown = now.getTime() - lastShownTime;
    const isFirstTimeToday = shownCount === 0;

    // Disabled Quiz-pending popup
    if (false && (isFirstTimeToday || timeSinceLastShown >= fourHoursInMillis)) {
      this.displayPopup();
      localStorage.setItem('shownCount', (shownCount + 1).toString());
      localStorage.setItem('lastShownTime', now.getTime().toString());
    }
  }


  closePopup() {
    this.showPopup = false;
    this.showAppraisalOverlay = false;
  }

  displayAppraisalPopup() {
    this.showPopup = true;
    this.showAppraisalOverlay = true;
  }
  closeAppraisalPopup() {
    this.showPopup = false;
    this.showAppraisalOverlay = false;
  }


  openITM() {
    window.open('https://lttsmyitservices.greenitco.com/login', '_blank');
    this.showPopup = false;
    this.showAppraisalOverlay = false;
  }

  openKaleidoscope() {
    window.open('https://performancemanager10.successfactors.com/sf/pmreviews?bplte_company=LTTS&_s.crb=sD%252fUrUyPwqvVLOngSTT2Dj4o4GHT%252fA3DNv3m39fZqHA%253d#/', '_blank'); // ✅ replace actual link
    this.showPopup = false;
    this.showAppraisalOverlay = false;
  }


  displayPopup() {
    this.empQuizPopup = true;
    this.showQuizOverlay = true;
  }

  get quickActionGreetingName(): string {
    return String(this.accountData?.profile?.employeeName || '').trim().replace(/\s+/g, ' ');
  }

  get declarationDone(): boolean {
    return this.declarationStatus === 'submitted' || this.declarationStatus === 'not-applicable';
  }

  get moodDone(): boolean {
    return !this.empFeedbackDiv || this.profileDetails?.userfeedbacksubmitted === true;
  }

  get quizDone(): boolean {
    return !this.quiz_access || this.profileDetails?.hasActiveQuizToday !== true;
  }

  get quizTileDisabled(): boolean {
    return !this.quiz_access || this.profileDetails?.hasActiveQuizToday === false;
  }

  // Auto-opens at most once per morning and once per afternoon, and never when everything is done.
  private evaluateQuickActionsAutoOpen(): void {
    this.showQuickActionLauncher = true;
    const now = new Date();
    const today = now.toDateString();
    const employeeId = this.accountData?.profile?.employeeId ?? '';
    if (this.declarationDone && this.moodDone && this.quizDone) {
      this.cdr.markForCheck();
      return;
    }

    const slot = now.getHours() < 12 ? 'morning' : 'afternoon';
    const key = `quickActionsShown_${employeeId}_${slot}`;
    if (localStorage.getItem(key) !== today) {
      localStorage.setItem(key, today);
      this.openPopupWidgetPicker();
    }
    this.cdr.markForCheck();
  }

  openPopupWidgetPicker(): void {
    if (!this.showPopupWidgetPicker) {
      const activeElement = document.activeElement;
      this.quickActionsPreviousFocus = activeElement instanceof HTMLElement && activeElement !== document.body
        ? activeElement
        : null;
    }
    this.showQuickActionLauncher = false;
    this.showPopupWidgetPicker = true;
    this.refreshQuickActionStatuses();
    setTimeout(() => this.quickActionCloseButton?.nativeElement.focus());
  }

  onQuickActionsKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closePopupWidgetPicker();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const dialog = event.currentTarget as HTMLElement;
    const focusableElements = dialog.querySelectorAll<HTMLElement>(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    const activeElement = document.activeElement as HTMLElement;

    if (!firstElement) {
      event.preventDefault();
      dialog.focus();
    } else if (event.shiftKey && (activeElement === firstElement || !dialog.contains(activeElement))) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && (activeElement === lastElement || !dialog.contains(activeElement))) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  private refreshQuickActionStatuses(): void {
    void this.declarationPromptService.checkPromptEligibility();

    if (this.quiz_access || this.empFeedbackDiv) {
      this.sessionService.fetchProfileData(this.accountData?.profile?.email).subscribe({
        error: (error) => console.error('Quick actions profile refresh failed', error),
      });
    }

    if (this.empFeedbackDiv) {
      this.gaugeChartService.checkFeedbackSubmitted().pipe(
        takeUntil(this.destroy$),
        catchError(() => of(null))
      ).subscribe((status) => {
        if (!status) {
          return;
        }

        this.profileDetails = {
          ...this.profileDetails,
          userfeedbacksubmitted: status.userFeedbackSubmitted,
        };
        this.cdr.markForCheck();
      });
    }
  }

  closePopupWidgetPicker(restoreFocus = true): void {
    this.showPopupWidgetPicker = false;
    this.showQuickActionLauncher = true;
    const previousFocus = this.quickActionsPreviousFocus;
    this.quickActionsPreviousFocus = null;
    if (restoreFocus) {
      setTimeout(() => {
        const focusTarget = previousFocus?.isConnected
          ? previousFocus
          : this.quickActionLauncher?.nativeElement;
        focusTarget?.focus();
      });
    }
  }

  openDeclarationWidget(): void {
    this.closePopupWidgetPicker(false);
    this.declarationPromptService.openPrompt();
  }

  openEmployeeMoodWidget(): void {
    this.closePopupWidgetPicker(false);
    this.openEmpPulse();
  }

  openQuizWidget(): void {
    this.closePopupWidgetPicker(false);
    this.displayPopup();
  }

  closeQuizPopup() {
    this.empQuizPopup = false;
    this.showQuizOverlay = false;
    this.userTrackingService.track('Quiz_Popup_Close_Clicked', { 'value': 'close' }, 'header');
  }

  navigateToUrl(path: any) {
    window.location.href = path

  }
  onChipClick(label: string): void {
    this.selectedChipLabel = label;
    this.commentText = label === 'Other' ? '' : label;
  }

  get isCommentEditable(): boolean {
    return this.selectedChipLabel === 'Other';
  }

  navigateToQuiz() {
    this.userTrackingService.track('Quiz_Proceed_Clicked', { 'value': 'Proceed' }, 'header');
    this.navigateToUrl('/quiz')
  }
  openEmpPulse() {
    if (!this.empFeedbackDiv) {
      return;
    }

    if (this.showOverlay) {
      this.toggleSidenav();
    }
    this.gaugeChartService.checkFeedbackSubmitted().pipe(
      // Fall back to the mood-capture view so a failed check never blocks the user
      catchError(() => of({ userFeedbackSubmitted: false, employeeMood: '' }))
    ).subscribe((userMood) => {
      if (userMood.userFeedbackSubmitted) {
        this.outputText = userMood.employeeMood;
        this.activeClassName = userMood.employeeMood;
        this.headingText = 'Employee Pulse';
        this.innerHead = "Thank you, <span>" + this.accountData.profile.employeeName + "</span>, for sharing your feedback for today!";
        this.hideCLosBtn = false;
        this.isConditionMet = true;
        this.disableMood = true;
        this.showFeedbackCapture = true;
        this.showFeedOverlay = true;
        this.cdr.detectChanges();
        return;
      }

      this.hideCLosBtn = true;
      this.isConditionMet = false;
      this.feedbackItems = this.shuffleArray([...this.feedbackItems]);
      this.showLoader = false;
      this.btnDisabled = false;
      this.showFeedbackCapture = true;
      this.showFeedOverlay = true;
      this.disableMood = false;
      this.userTrackingService.track('MoodPulse_Clicked', { 'value': 'MoodPulse' }, 'header');
      this.cdr.detectChanges();
    });
  }
  private shuffleArray<T>(arr: T[]): T[] {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  closeFeedback() {
    this.showFeedbackCapture = false;
    this.showFeedOverlay = false;
    this.userTrackingService.track('MoodPulseClose_Clicked', { 'value': 'close' }, 'header');
  }



  showRemainingHeader() {
    this.showMoreHeader = !this.showMoreHeader;
  }
  headerClick(name: any) {
    this.userTrackingService.track('header_link_clicked', { 'value': name }, 'header');
  }

  toggleClose() {
    this.showMoreHeader = false;
  }
  navigateToCMS() {
    this.userTrackingService.track('CMS_Clicked', { 'value': 'Open' }, 'header');
    this.toggleClose();
  }

  navigateDepartment(id, name) {
    this.showMoreHeader = false;
    this.userTrackingService.track('Department_Clicked', { 'value': name }, "Header");
    this.router.navigate(["departments"], { fragment: id });
  }
  closeSearchTab(): void {
    this.showSearchTab = false;
  }

  getRemindersListData(userId) {
    const me = this;
    me.dynamicStackService.getReminderData(userId).subscribe(
      (state: Store.State) => {
        if (state instanceof RemindersLoadingState) {
          me.reminders = [];
          me.remindersLoading = true;
          return;
        }
        if (state instanceof RemindersLoadedState) {
          me.reminders = state?.data?.data;
          me.remindersLoading = false;
          return;
        }
      },
      (state: RemindersLoadingErrorState) => {
        me.remindersLoading = false;
        me.reminders = [];
        return;
      }
    );
  }

  setGreetingMessage(): void {
    const currentHour = new Date().getHours();
    if (currentHour >= 5 && currentHour < 12) {
      this.greetingMessage = "Good Morning";
    } else if (currentHour >= 12 && currentHour < 17) {
      this.greetingMessage = "Good Afternoon";
    } else if (currentHour >= 17 && currentHour < 24) {
      this.greetingMessage = "Good Evening";
    } else {
      this.greetingMessage = "Good Evening";
    }
  }

  closeMenu() {
    this.showCancelLogo = false;
  }
  showList() {
    this.showCancelLogo = !this.showCancelLogo;
  }

  onMenuItemClick(link: string) {
    this.activeLink = link;

    if (link === "feed" || link === "/feed") {
      let url = window["env"].feedsRedirectUri;
      window.open(url, "_self");
    }

    this.router.navigate([link]);
    this.closeMenu();
  }

  navigateById(id) {
    this.router.navigateByUrl("my-team/" + btoa(id));
    this.userTrackingService.track('MyTeams_Clicked', { 'value': 'MyTeams' }, 'header');
    if (this.showOverlay) {
      this.toggleSidenav();
    }
  }

  navigateTo(link: string) {
    if (link === "feed" || link === "/feed") {
      let url = window["env"].feedsRedirectUri;
      window.open(url, "_self");
    }
    // this.router.navigate([link]);
  }

  userprofile() {
    this.closeMenu();
    this.userTrackingService.track('Profile_clicked', { 'value': 'Profile' }, 'header');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleChildEvent(event) {
    const me = this;
    if (event) {
      me.popover.hide();
    }
  }

  toggleFeedback() {
    this.feedBack = !this.feedBack;
  }

  getPeopleDetails(searchOption:any, groupName:any) {
    if (groupName === "People") {
      this.dialogService.open(PeopleDetailsComponent, {
        context: {
          peopleDetails: searchOption,
        },
        // closeOnBackdropClick: false,
      });
    } else {
      window.open(searchOption.app_url, "_blank");
    }
  }

  handleSearchInput() {
    this.showSearchInput = !this.showSearchInput;
    this.inputFormControl.reset();
    this.filteredGroups$ = of([]);
    this.searchGroups = [];
    this.showSearchTab = false;
    this.activeTabIndex$.next(-1);
    this.activeTabIndex$.next(0);
    this.userTrackingService.track('clear_search_clicked', `{'value': Global_Search_Closed}`, 'header');
    this.searText = '';
    // this.userTrackingService.track('GlobalSearch_Clicked', 'Search_Closed', 'header');
  }

  getUserProfileData() {
    const me = this;
    // const empId = 10009072;

    me.profileData = me.profileDetails;
    if (me.profileData?.birthdayFlag) {
      this.greetingMessage = "Happy Birthday";
    } else if (me.profileData?.workanniversaryFlag) {
      this.greetingMessage = "Happy Work Anniversary";
    } else {
      this.setGreetingMessage();
    }

    me.username = me.profileData?.employeeName;
    me.employeeId = me.profileData?.employeeId;
    me.isMnAUser = me.profileData?.hasMnARole;
    me.hasActiveTownhall = me.profileData?.hasActiveTownHallToday;
    me.hasActiveQuiz = me.profileData?.hasActiveQuizToday;
    me.hasActiveISMS = me.profileData?.isms_completed;
    me.hasActiveDataPrivacy = me.profileData?.dataprivacy_completed;
    me.AlinaAccess = me.profileData?.hasAlinaAccess;
    me.hasCmsAccess = me.profileData?.hasCMSAccess;
    this.permissionService.setPermission("LINA", me.AlinaAccess);
    this.getProfileImage(this.accountData?.profile);

    const reqBody = {
      bu_applicable: me.profileData?.businessUnit
        ? me.profileData.businessUnit
        : "",
      du_applicable: me.profileData?.divisionUnit
        ? me.profileData.divisionUnit
        : "",
      grade_applicable: me.profileData?.grade ? me.profileData.grade : "",
      // "designation": profileData.designation ? profileData.designation : '',
      country_applicable: me.profileData?.primaryLocation?.[0]?.building
        ? me.profileData.primaryLocation?.[0]?.building
        : "",
      app_group: "",
    };

    this.getAllApplications(reqBody);

    return;
  }

  getAllApplications(reqBody) {
    const me = this;
    me.applicationService
      .getAllApplications(reqBody)
      .subscribe((state: Store.State) => {
        if (state instanceof GetAllCategoriesLoadingState) {
          me.loading = true;
          return;
        }
        if (state instanceof GetAllCategoriesLoadedState) {
          me.categoriesData = state.data.data;

          // me.loadUserConfig();

          this.categoriesList = _.orderBy(
            _.uniqBy(
              this.categoriesData.map((el) => {
                return {
                  title: el.app_group,
                  categoryIcon: el.app_group_icon,
                  isSelected: false,
                };
              }),
              "title"
            ),
            ["title"],
            ["asc"]
          );

          this.categoriesListCopy = _.cloneDeep(this.categoriesList);

          this.groupedCategoriesData = _.groupBy(
            this.categoriesData,
            "app_group"
          );

          this.categoriesList = this.categoriesList.map((item) => {
            return (item = {
              item,
              children: this.groupedCategoriesData[item.title]
                .filter((innerItem) => item.title === innerItem.app_group)
                .sort((a, b) =>
                  a.app_name
                    .toLowerCase()
                    .localeCompare(b.app_name.toLowerCase())
                ),
            });
          });

          this.appMenu = [
            {
              label: "MyApps",
              url: "",
              children: this.categoriesList,
            },
          ];

          Object.keys(this.groupedCategoriesData).forEach((category) => {
            this.groupedCategoriesData[category] = _.orderBy(
              this.groupedCategoriesData[category],
              [(app) => app.app_name.toLowerCase()], // Case-insensitive sort
              ["asc"]
            );
          });

          me.loading = false;

          return;
        }
        (state: GetAllCategoriesLoadingErrorState) => {
          me.loading = false;
          return;
        };
      });
  }

  // getProfileImage(user) {
  //   const me = this;
  //   const id = [user?.email];

  //   if (
  //     AppLocalStorage.get(
  //       "PROFILE_IMAGE",
  //       "PROFILE_IMAGE" + String(id).toLowerCase()
  //     )
  //   ) {
  //     me.profileData = {
  //       ...me.profileData,
  //       profileImage: null,
  //     };
  //     me.profileData.profileImage = AppLocalStorage.get(
  //       "PROFILE_IMAGE",
  //       "PROFILE_IMAGE" + String(id).toLowerCase()
  //     )[0]?.userImage;
  //   } else {
  //     me.sessionService.getProfileImage(id).subscribe((state: Store.State) => {
  //       if (state instanceof profileImageLoadingState) {
  //         return;
  //       }
  //       if (state instanceof profileImageLoadedState) {
  //         me.profileData = {
  //           ...me.profileData,
  //           profileImage: null,
  //         };
  //         me.profileData.profileImage = state.data?.data[0]?.userImage;
  //         me.cdr.detectChanges();
  //         return;
  //       }
  //       (state: profileImageLoadingErrorState) => {
  //         return;
  //       };
  //     });
  //   }
  // }
  getProfileImage(user: any) {
    this.sessionService
      .getProfileImage([user.email])
      .subscribe((state: Store.State) => {
        if (state instanceof profileImageLoadingState) {
          return;
        } else if (state instanceof profileImageLoadedState) {
          this.profileData.profileImage = state.data.data[0]?.userImage;
          this.cdr.detectChanges();
        } else if (state instanceof profileImageLoadingErrorState) {
          this.profileData.profileImage = null;
        }
      });
  }


  getProfileImageSrc(image: string): string {
    if (image && image.startsWith("data:image/png;base64,")) {
      return image;
    }
    if (image && !image.startsWith("data:image/png;base64,")) {
      return "data:image/png;base64," + image;
    }
    return this.cmsbase_url + "wp-content/uploads/2025/05/dumy.jpg";
  }

  requestsDataLoading: boolean;
  requestAvailableInDate: boolean = true;
  reqForApprovalsData: any = [];

  fetchRequestForApprovalsData(emailId: string) {
    const me = this;
    // emailId='Kancharikuntla.Anilreddy@ltts.com'
    me.headerService.fetchRequestsForApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForApprovalsLoadingState) {
          me.requestsDataLoading = true;
          me.reqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof RequestsForApprovalsLoadedState) {
          me.reqForApprovalsData = state.data.data;
          me.requestsDataLoading = false;
          me.requestAvailableInDate = me.reqForApprovalsData.every(
            (obj) => obj.totalTicketsCount === 0
          );
          me.cdr.detectChanges();

          return;
        }
      },
      (state: RequestsForApprovalsLoadingErrorState) => {
        me.requestsDataLoading = false;
        me.reqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }

  attendanceRequestsDataLoading: boolean;
  attendanceRequestAvailableInDate: boolean = false;
  attendanceReqForApprovalsData: any = [];

  fetchRequestsForAttendanceApprovals(emailId: string) {
    const me = this;
    me.headerService.fetchRequestsForAttendanceApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForAttendanceApprovalsLoadingState) {
          me.attendanceRequestsDataLoading = true;
          me.attendanceReqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof RequestsForAttendanceApprovalsLoadedState) {
          me.attendanceReqForApprovalsData = state.data.data;
          me.attendanceRequestsDataLoading = false;
          me.attendanceRequestAvailableInDate =
            me.attendanceReqForApprovalsData.every(
              (obj) => obj.totalTicketsCount !== 0
            );
          me.cdr.detectChanges();
          return;
        }
      },
      (state: RequestsForAttendanceApprovalsLoadingErrorState) => {
        me.attendanceRequestsDataLoading = false;
        me.attendanceReqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }

  leaveRequestsDataLoading: boolean;
  leaveRequestAvailableInDate: boolean = false;
  leaveReqForApprovalsData: any = [];

  fetchRequestsForLeaveApprovals(emailId: string) {
    const me = this;
    me.headerService.fetchRequestsForLeaveApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForLeaveApprovalsLoadingState) {
          me.leaveRequestsDataLoading = true;
          me.leaveReqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof RequestsForLeaveApprovalsLoadedState) {
          me.leaveReqForApprovalsData = state.data.data;
          me.leaveRequestsDataLoading = false;
          me.leaveRequestAvailableInDate = me.leaveReqForApprovalsData.every(
            (obj) => obj.totalTicketsCount !== 0
          );
          me.cdr.detectChanges();

          return;
        }
      },
      (state: RequestsForLeaveApprovalsLoadingErrorState) => {
        me.leaveRequestsDataLoading = false;
        me.leaveReqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }

  carRequestsDataLoading: boolean;
  carRequestAvailableInDate: boolean = false;
  carReqForApprovalsData: any = [];

  fetchRequestsForCarApprovals(emailId: string) {
    const me = this;
    me.headerService.fetchRequestsForCarApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForCarApprovalsLoadingState) {
          me.carRequestsDataLoading = true;
          me.carReqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof RequestsForCarApprovalsLoadedState) {
          me.carReqForApprovalsData = state.data.data;
          me.carRequestsDataLoading = false;
          me.carRequestAvailableInDate = me.carReqForApprovalsData.every(
            (obj) => obj.totalTicketsCount !== 0
          );
          me.cdr.detectChanges();

          return;
        }
      },
      (state: RequestsForCarApprovalsLoadingErrorState) => {
        me.carRequestsDataLoading = false;
        me.carReqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }

  accommodationRequestsDataLoading: boolean;
  accommodationRequestAvailableInDate: boolean = false;
  accommodationReqForApprovalsData: any = [];

  fetchRequestsForAccommodationApprovals(emailId: string) {
    const me = this;
    me.headerService.fetchRequestsForAccommodationApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForAccommodationApprovalsLoadingState) {
          me.accommodationRequestsDataLoading = true;
          me.accommodationReqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof RequestsForAccommodationApprovalsLoadedState) {
          me.accommodationReqForApprovalsData = state.data.data;
          me.accommodationRequestsDataLoading = false;
          me.accommodationRequestAvailableInDate =
            me.accommodationReqForApprovalsData.every(
              (obj) => obj.totalTicketsCount !== 0
            );
          me.cdr.detectChanges();

          return;
        }
      },
      (state: RequestsForAccommodationApprovalsLoadingErrorState) => {
        me.accommodationRequestsDataLoading = false;
        me.accommodationReqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }

  synergyRequestsDataLoading: boolean;
  synergyRequestAvailableInDate: boolean = false;
  synergyReqForApprovalsData: any = [];

  fetchRequestsForSynergyApprovals(emailId) {
    const me = this;
    me.headerService.fetchPendingSynergyRequests(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof SynergyPendingRequestsLoadingState) {
          me.synergyRequestsDataLoading = true;
          me.synergyReqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof SynergyPendingRequestsLoadedState) {
          me.synergyReqForApprovalsData = state.data.data;
          me.synergyRequestsDataLoading = false;
          me.synergyRequestAvailableInDate =
            me.synergyReqForApprovalsData.totalTicketsCount !== 0;
          me.cdr.detectChanges();
          return;
        }
      },
      (state: SynergyPendingRequestsLoadingErrorState) => {
        me.synergyRequestsDataLoading = false;
        me.synergyReqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }
  forexRequestsDataLoading: boolean;
  forexRequestAvailableInDate: boolean = false;
  forexReqForApprovalsData: any = [];

  fetchRequestsForForexApprovalsData(emailId: string) {
    const me = this;
    me.headerService.fetchRequestsForForexApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof ForexPendingRequestsLoadingState) {
          me.forexRequestsDataLoading = true;
          me.forexReqForApprovalsData = [];
          me.cdr.detectChanges();
          return;
        }
        if (state instanceof ForexPendingRequestsLoadedState) {
          me.forexReqForApprovalsData = state.data.data;
          me.forexRequestsDataLoading = false;
          me.forexRequestAvailableInDate = me.forexReqForApprovalsData.every(
            (obj) => obj.totalTicketsCount !== 0
          );
          me.cdr.detectChanges();
          return;
        }
      },
      (state: ForexPendingRequestsLoadingErrorState) => {
        me.forexRequestsDataLoading = false;
        me.forexReqForApprovalsData = [];
        me.cdr.detectChanges();
        return;
      }
    );
  }

  searchApplication(query: string) {
    const me = this;
    me.homeservice.applicationSearch(query).subscribe(
      (state: Store.State) => {
        if (state instanceof ApplicationSearchLoadingState) {
          me.applicationSearchLoading = true;
          return;
        }

        if (state instanceof ApplicationSearchLoadedState) {
          let applicationData: any = state.data.data;

          if (
            applicationData.peopleList.length === 0 &&
            applicationData.appList.length === 0
          ) {
            me.applicationSearchEmpty = true;
          } else {
            me.applicationSearchEmpty = false;
          }

          // Map raw data to tab groups
          let appgroups = Object.keys(applicationData).map((key) => ({
            name:
              key === "peopleList"
                ? "People"
                : key === "appList"
                  ? "Apps"
                  : key,
            children: applicationData[key].map((item) => ({ ...item })),
          }));
          const priorityMap = {
            Apps: 1,
            People: 2,
          };

          appgroups.sort((a, b) => {
            return (priorityMap[a.name] || 99) - (priorityMap[b.name] || 99);
          });

          this.activeTabIndex$.next(0);
          this.filteredGroups$ = of(appgroups);
          this.searchGroups = appgroups;
          this.showSearchTab = true;
          me.cdr.detectChanges();
          me.applicationSearchLoading = false;

          return;
        }
      },
      (state: ApplicationSearchLoadingErrorState) => {
        return;
      }
    );
  }

  trackByGroupName(index: number, group: any): string {
    return group.name;
  }

  searchRequest(query: any) {
    const me = this;
    me.homeservice.applicationSearch(query).subscribe(
      (state: Store.State) => {
        if (state instanceof BingSearchLoadingState) {
          return;
        }

        if (state instanceof BingSearchLoadedState) {
          me.searchData = state.data.data;
          me.showSearchResults = true; // Show the search results list

          return;
        }
      },
      (state: BingSearchLoadingErrorState) => {
        return;
      }
    );
  }

  onResultClick(result: any): void {
    this.showSearchResults = false; // Hide the search results list
    this.searchData = [];
    // this.searchControl.setValue('');
    // this.searchControl.setValue(item); // Optionally set the selected item in the search input
    this.selectedResult = result; // Store the selected result
    this.getsearchImage(this.selectedResult.mail);
  }

  getsearchImage(user) {
    const me = this;
    const id = [user];
    if (
      AppLocalStorage.get(
        "PROFILE_IMAGE",
        "PROFILE_IMAGE" + String(id).toLowerCase()
      )
    ) {
      this.profileImage = AppLocalStorage.get(
        "PROFILE_IMAGE",
        "PROFILE_IMAGE" + String(id).toLowerCase()
      )[0]?.userImage;
    } else {
      me.sessionService.getProfileImage(id).subscribe((state: Store.State) => {
        if (state instanceof profileImageLoadingState) {
          return;
        }
        if (state instanceof profileImageLoadedState) {
          this.profileImage = state.data.data[0].userImage;
          me.cdr.detectChanges();

          return;
        }
        (state: profileImageLoadingErrorState) => {
          return;
        };
      });
    }
  }

  clearSearchResults(): void {
    this.searchData = [];
    this.showSearchResults = false;
  }

  cancel() {
    this.selectedResult = null; // Reset the selected result
    this.profileImage = "";
    this.searchControl.setValue("");
    this.clearSearchResults();
    // this.isShowing = false;
  }

  private filterChildren(children: string[], filterValue: string) {
    return children.filter((optionValue) =>
      optionValue.toLowerCase().includes(filterValue)
    );
  }

  private filter(value: string): Group[] {
    const filterValue = value.toLowerCase();
    return this.groups
      .map((group) => {
        return {
          name: group.name,
          children: this.filterChildren(group.children, filterValue),
        };
      })
      .filter((group) => group.children.length);
  }

  trackByFn(index, item) {
    return item.name;
  }
  showOverlay = false;
  selectedMenuOption: any;

  toggleSidenav(option?: any) {
    this.selectedMenuOption = option;
    this.showOverlay = !this.showOverlay;
    // this.sidebarService.toggle();

    // toggleSidebar() {
    this.sidebarService.getSidebarState("menu-sidebar").subscribe((state) => {
      if (state === "expanded") {
        // if(this.selectedMenuOption == 'req-for-approval'){
        // this.fetchRequestForApprovalsData(this.accountData.profile.email);
        // }
        // this.showOverlay = false;
        this.sidebarService.collapse("menu-sidebar");
        this.userTrackingService.track('notification_clicked', { 'value': 'Closed' }, 'header');
      } else {
        // this.showOverlay = true;
        this.sidebarService.expand("menu-sidebar");
        this.userTrackingService.track('notification_clicked', { 'value': 'Open' }, 'header');
      }
    });
    // }
  }

  userTrack() {
    this.userTrackingService.track('logo_clicked', { 'value': 'logo' }, 'header');
    if (this.showOverlay) {
      this.toggleSidenav();
    }
  }

  redirectBOD(name: any) {
    // this.toggleSidenav();
    this.userTrackingService.track('header_link_clicked', { 'value': name }, 'header');
    window.open('https://www.ltts.com/about-us/board-of-directors', '_blank');
    if (this.showOverlay) {
      this.toggleSidenav();
    }
  }

  navigateToHome() {
    this.router.navigate(["/home"]);
    if (this.showOverlay) {
      this.toggleSidenav();
    }
    this.sidebarService.collapse("menu-sidebar");
    this.userTrackingService.track('Notification_Return_clicked', { 'value': "Notification_Return" }, 'header');
  }
  cancelClicked() {
    this.showOverlay = !this.showOverlay;
    this.sidebarService.collapse("menu-sidebar");
    this.userTrackingService.track('Notification_Cancel_clicked', { 'value': "Notification_Cancel" }, 'header');
  }

  collapseSidenav() {
    this.sidebarService.getSidebarState("menu-sidebar").subscribe((state) => {
      if (state === "expanded") {
        this.showOverlay = !this.showOverlay;
        // if(this.selectedMenuOption == 'req-for-approval'){
        // this.fetchRequestForApprovalsData(this.accountData.profile.email);
        // }
        this.sidebarService.collapse("menu-sidebar");
      }
    });
  }

  toggleAppsDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.showAppsDropdown = !this.showAppsDropdown;
  }
  getAppIcon(departmentName: string): string {
    if (!departmentName) return "";
    const normalized = departmentName.trim();
    return APP_ICONS[normalized] || APP_ICONS["ORG"];
  }
  getInitials(name: string): string {
    if (!name) return "";
    const parts = name.trim().split(" ");
    const first = parts[0]?.charAt(0).toUpperCase() || "";
    const last =
      parts.length > 1 ? parts[parts.length - 1].charAt(0).toUpperCase() : "";
    return first + last;
  }
  toggleSearchOpen(event: MouseEvent) {
    event.stopPropagation();
    this.showSearchInput = !this.showSearchInput;
    this.collapseSidenav();
    this.userTrackingService.track('search_icon_Clicked', `{'value':'Global_Search_Opened'}`, 'header');
    setTimeout(() => {
      if (this.showSearchInput && this.searchInputRef) {
        this.searchInputRef.nativeElement.focus();
      }
    });
  }

  feedbackItems = [
    { title: 'Excellent', className: 'Excellent', icon: '/assets/feedback-icons/Excellent-latest.png' },
    { title: 'Happy', className: 'Happy', icon: '/assets/feedback-icons/Happy-latest.png' },
    { title: 'Okay', className: 'Okay', icon: '/assets/feedback-icons/Okay-latest.png' },
    { title: 'Could be better', className: 'NotOkay', icon: '/assets/feedback-icons/better.png' }
  ];
  isSubmitDisabled(): boolean {
    if (!this.activeClassName) return true;
    if (!this.commentText.trim()) return true;
    return false;
  }




  // Method to handle the click event
  handleSpanClick(clickedItem: { className: string, icon: string }): void {
    this.isExpanded = true;
    if (this.activeClassName !== clickedItem.className) {
      this.selectedChipLabel = null;
      this.commentText = '';
    }
    this.activeClassName = clickedItem.className;
    this.outputText = this.activeClassName;
    this.btnDisabled = false;
    this.showComment = !!this.activeClassName;
    this.myButtonRef.nativeElement.focus();
  }
  async fetchAppraisalData() {
    try {
      const observable: any =
        await this.intranetService.fetchAppraisalData();
      observable.subscribe({
        next: (data: any) => {
          this.appraisalData =
            data?.appraisalPending === true;

          // show popup only if backend says true
          if (this.appraisalData) {
            this.checkAppraisalPopup();
          }
        },
        error: (err: any) => {
          console.error(
            'Error fetching appraisal data',
            err
          );
        }
      });
    } catch (error) {
      console.error(
        'Appraisal token error',
        error
      );
    }
  }
  checkAppraisalPopup() {

    // stop if appraisal disabled

    if (!this.appraisalData) {

      return;

    }

    const now = new Date();

    const today = now.toDateString();

    const lastShownDate =

      localStorage.getItem(

        'appraisalLastShownDate'

      );

    const lastShownTime =

      parseInt(

        localStorage.getItem(

          'appraisalLastShownTime'

        ) || '0',

        10

      );

    let shownCount =

      parseInt(

        localStorage.getItem(

          'appraisalShownCount'

        ) || '0',

        10

      );

    // reset every new day

    if (lastShownDate !== today) {

      shownCount = 0;

      localStorage.setItem(

        'appraisalLastShownDate',

        today

      );

      localStorage.setItem(

        'appraisalShownCount',

        '0'

      );

      localStorage.removeItem(

        'appraisalLastShownTime'

      );

    }

    this.displayAppraisalPopup();

  }


  submitMood() {
    this.showLoader = true;
    this.btnDisabled = true;
    this.disableMood = true;
    if (this.outputText != '') {
      const userDate = new Date();
      const utcString = userDate.toISOString();
      const offset = userDate.getTimezoneOffset() * 60000;
      const localISOTime = new Date(userDate.getTime() - offset).toISOString();
      const userLocalDate = localISOTime;
      let setEmpMood = AppLocalStorage.get('PROFILE_DATA', 'PROFILE_DATA');
      setEmpMood.hasEmployeMoodSubmited = true;
      AppLocalStorage.set('PROFILE_DATA', 'PROFILE_DATA', setEmpMood);
      let moodObj = { localTime: userLocalDate, utcTime: utcString, employeeMood: this.outputText, comment: this.commentText };
      const feedpath = `${environment.api.core.base3}/${environment.api.feedBack.moodSubmit.endpoint}`;
      const sessionData: any = AppLocalStorage.get('SESSION', 'SESSION') || {};
      this.token = sessionData?.token || '';

      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      if (this.token) {
        headers = headers.set('Authorization', `Bearer ${this.token}`);
      }
      this.http.post(feedpath, moodObj, { headers, observe: 'response' }).pipe(
        catchError(err => {
          this.toastrService.danger("Feedabck submit failed!.", "Error", { duration: 3000 });
          this.showFeedbackCapture = false;
          this.showFeedOverlay = false;
          return EMPTY; // Prevent application crash on tracking errors
        })
      ).subscribe({
        next: () => {
          this.showFeedbackCapture = false;
          this.showFeedOverlay = false;
          this.activeClassName = '';
          this.sessionService.fetchProfileData(this.accountData.profile.email);
          this.profileDetails = { ...this.profileDetails, userfeedbacksubmitted: true };
          this.cdr.detectChanges();
        }
      });
      this.userTrackingService.track('MoodPulseSubmit_Clicked', { 'value': 'submit' }, 'header');
    } else {
      this.toastrService.danger("Please select your mood for the day!.", "Error", { duration: 3000 });
    }
  }
  get completedCount(): number {
    return (this.hasActiveISMS ? 1 : 0) + (this.hasActiveDataPrivacy ? 1 : 0);
  }
  async fetchTalentAIData() {
    try {
      const observable: any =
        await this.intranetService.fetchTalentAI();
      observable.subscribe({
        next: (data: any) => {
          this.talentAIData = data?.talentAICompleted === false;
        },
        error: (err: any) => {
          console.error('Error fetching data', err);
        }
      });
    } catch (error) {
      console.error('Token error', error);
    }
    //  const sessionData: any = AppLocalStorage.get('SESSION', 'SESSION') || {};
    //     this.token = sessionData?.token || '';
    //     let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //     if (this.token) {
    //       headers = headers.set('Authorization', `Bearer ${this.token}`);
    //     }
    //     const url = `${environment.api.core.base}ModernIntranet/check-talentai-completion`;

    //     this.http
    //       .post<any>(url, { headers, observe: 'response' })
    //       .pipe(
    //         map((res: HttpResponse<any>) => res.body?.data ?? {}),
    //         catchError(() => EMPTY)
    //       )
    //       .subscribe({
    //         next: (data) => {
    //           this.talentAIData = data?.talentAICompleted === false;
    //         },
    //       });
  }
  navigateToTalentAI() {
    // Close the popup before navigating
    this.closeTalentPopup();

    if (window.innerWidth <= 768) {
      this.sidebarService.collapse('menu-sidebar');
      this.showOverlay = !this.showOverlay;
    }
    this.router.navigate(['/talentai']);
  }
  handleMyAppClick(item) {
    this.userTrackingService.track('MyApps_Clicked', { 'Application': item.app_group, 'SubApplication': item.app_name }, "Header");
  }
  navigateToTownhall() {
    this.userTrackingService.track('Townhall_Clicked', { 'value': 'Open' }, 'header');
    this.toggleClose()
  }
}
